<template>
  <div class="thank-you-screen">
    <vs-card class="thank-you-card">
      <div class="icon-container">
        <vs-icon icon="check_circle" class="success-icon" />
      </div>
      <h2>{{$t("customers.label.ThankYou")}}</h2>
      <p class="message">
        {{$t("customers.label.ConnectionActivated")}}
        {{ this.$route.query.id }}
      </p>
      <vs-button color="primary" type="filled" @click="goToCustomer">
        {{$t("customers.label.GoToCustomerDetail")}}
      </vs-button>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "ThankYouScreen",
  methods: {
    goToCustomer() {
      this.$router.push(`/customers/view_customer/${this.$route.query.id}`);
    },
  },
};
</script>

<style scoped>
.thank-you-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.thank-you-card {
  text-align: center;
  padding: 20px;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
}

.icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.success-icon {
  font-size: 4rem;
  color: #00c8b2; /* Vuesax primary success color */
}

h2 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #333;
}

.message {
  font-size: 1rem;
  margin-bottom: 20px;
  color: #666;
}

.vs-button {
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
}
</style>
